"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(require("D:\\\u9879\u76EE\u7BA1\u7406\\\u65E7\u6362\u65B0\\\u6E90\u7801\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\@babel\\runtime\\regenerator\\index.js"));

var _index2 = _interopRequireDefault(require("@/components/Tinymce/index"));

var _store = require("@/api/store");

var _logistics = require("@/api/logistics");

var _public = require("@/libs/public");

var _marketing = require("@/api/marketing");

var _creatTemplates = _interopRequireDefault(require("@/views/systemSetting/logistics/shippingTemplates/creatTemplates"));

var _validate = require("@/utils/validate");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var defaultObj = {
  image: '',
  images: '',
  imagess: [],
  title: '',
  info: '',
  num: 1,
  unitName: '',
  sort: 0,
  giveIntegral: 0,
  ficti: 0,
  isShow: false,
  tempId: '',
  attrValue: [{
    image: '',
    price: 0,
    cost: 0,
    otPrice: 0,
    stock: 0,
    quota: 1,
    barCode: '',
    weight: 0,
    volume: 0
  }],
  attr: [],
  selectRule: '',
  content: '',
  specType: false,
  id: 0,
  timeId: 1,
  startTime: '',
  stopTime: '',
  timeVal: [],
  status: 0
};
var objTitle = {
  price: {
    title: '秒杀价'
  },
  cost: {
    title: '成本价'
  },
  otPrice: {
    title: '原价'
  },
  stock: {
    title: '库存'
  },
  quota: {
    title: "限量"
  },
  barCode: {
    title: '商品编号'
  },
  weight: {
    title: '重量（KG）'
  },
  volume: {
    title: '体积(m³)'
  }
};
var _default = {
  name: "creatSeckill",
  components: {
    CreatTemplates: _creatTemplates.default,
    Tinymce: _index2.default
  },
  data: function data() {
    return {
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < new Date().setTime(new Date().getTime() - 3600 * 1000 * 24);
        }
      },
      props2: {
        children: 'child',
        label: 'name',
        value: 'id',
        multiple: true,
        emitPath: false
      },
      grid2: {
        xl: 8,
        lg: 10,
        md: 12,
        sm: 24,
        xs: 24
      },
      currentTab: 0,
      formThead: Object.assign({}, objTitle),
      formValidate: Object.assign({}, defaultObj),
      loading: false,
      fullscreenLoading: false,
      merCateList: [],
      // 商户分类筛选
      shippingList: [],
      // 运费模板
      seckillTime: [],
      ruleValidate: {
        productId: [{
          required: true,
          message: '请选择商品',
          trigger: 'change'
        }],
        title: [{
          required: true,
          message: '请输入商品标题',
          trigger: 'blur'
        }],
        attrValue: [{
          required: true,
          message: '请选择商品属相',
          trigger: 'change',
          type: 'array',
          min: '1'
        }],
        num: [{
          required: true,
          message: '请输入活动次数',
          trigger: 'blur'
        }],
        unitName: [{
          required: true,
          message: '请输入单位',
          trigger: 'blur'
        }],
        info: [{
          required: true,
          message: '请输入秒杀商品简介',
          trigger: 'blur'
        }],
        tempId: [{
          required: true,
          message: '请选择运费模板',
          trigger: 'change'
        }],
        timeId: [{
          required: true,
          message: '请选择活动时间',
          trigger: 'change'
        }],
        image: [{
          required: true,
          message: '请上传商品图',
          trigger: 'change'
        }],
        imagess: [{
          required: true,
          message: '请上传商品轮播图',
          type: 'array',
          trigger: 'change'
        }],
        specType: [{
          required: true,
          message: '请选择商品规格',
          trigger: 'change'
        }],
        timeVal: [{
          required: true,
          message: '请选择活动日期',
          trigger: 'change',
          type: 'array'
        }]
      },
      manyTabDate: {},
      manyTabTit: {},
      attrInfo: {},
      tempRoute: {},
      multipleSelection: [],
      productId: 0,
      OneattrValue: [Object.assign({}, defaultObj.attrValue[0])],
      // 单规格
      ManyAttrValue: [Object.assign({}, defaultObj.attrValue[0])] // 多规格

    };
  },
  computed: {
    attrValue: function attrValue() {
      var obj = Object.assign({}, defaultObj.attrValue[0]);
      delete obj.image;
      return obj;
    }
  },
  created: function created() {
    this.$watch('formValidate.attr', this.watCh);
    this.tempRoute = Object.assign({}, this.$route);
  },
  mounted: function mounted() {
    var _this2 = this;

    (0, _public.getSeckillList)(1).then(function (res) {
      _this2.seckillTime = res.list;
    });
    this.formValidate.imagess = [];

    if (this.$route.params.id) {
      this.setTagsViewTitle();
      this.getInfo();
      this.currentTab = 1;
    }

    this.getShippingList();
    this.getCategorySelect();
  },
  methods: {
    watCh: function watCh(val) {
      var tmp = {};
      var tmpTab = {};
      this.formValidate.attr.forEach(function (o, i) {
        // tmp['value' + i] = { title: o.attrName }
        // tmpTab['value' + i] = ''
        tmp[o.attrName] = {
          title: o.attrName
        };
        tmpTab[o.attrName] = '';
      });
      this.manyTabTit = tmp;
      this.manyTabDate = tmpTab;
      this.formThead = Object.assign({}, this.formThead, tmp);
    },
    handleRemove: function handleRemove(i) {
      this.formValidate.imagess.splice(i, 1);
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 点击商品图
    modalPicTap: function modalPicTap(tit, num, i) {
      var _this = this;

      this.$modalUpload(function (img) {
        if (tit === '1' && !num) {
          _this.formValidate.image = img[0].sattDir;
          _this.ManyAttrValue[0].image = img[0].sattDir;
        }

        if (tit === '2' && !num) {
          if (img.length > 10) return this.$message.warning("最多选择10张图片！");
          if (img.length + _this.formValidate.imagess.length > 10) return this.$message.warning("最多选择10张图片！");
          img.map(function (item) {
            _this.formValidate.imagess.push(item.sattDir);
          });
        }

        if (tit === '1' && num === 'duo') {
          _this.ManyAttrValue[i].image = img[0].sattDir;
        }
      }, tit, 'content');
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.formValidate.timeVal = e;
      this.formValidate.startTime = e ? e[0] : "";
      this.formValidate.stopTime = e ? e[1] : "";
    },
    changeGood: function changeGood() {
      var _this = this;

      this.$modalGoodList(function (row) {
        _this.formValidate.image = row.image;
        _this.productId = row.id; // _this.formValidate.productId = row.id
      });
    },
    handleSubmitNest1: function handleSubmitNest1() {
      if (!this.formValidate.image) {
        return this.$message.warning("请选择商品！");
      } else {
        this.currentTab++;
        if (!this.$route.params.id) this.getProdect(this.productId);
      }
    },
    // 商品分类；
    getCategorySelect: function getCategorySelect() {
      var _this3 = this;

      (0, _store.categoryApi)({
        status: -1,
        type: 1
      }).then(function (res) {
        _this3.merCateList = _this3.filerMerCateList(res);
      });
    },
    filerMerCateList: function filerMerCateList(treeData) {
      return treeData.map(function (item) {
        if (!item.child) {
          item.disabled = true;
        }

        item.label = item.name;
        return item;
      });
    },
    // 运费模板；
    getShippingList: function getShippingList() {
      var _this4 = this;

      (0, _logistics.shippingTemplatesList)(this.tempData).then(function (res) {
        _this4.shippingList = res.list;
      });
    },
    // 运费模板
    addTem: function addTem() {
      this.$refs.addTemplates.dialogVisible = true;
      this.$refs.addTemplates.getCityList();
    },
    // 商品详情
    getInfo: function getInfo() {
      if (!this.$route.params.id) {
        this.getProdect(this.productId);
      } else {
        this.getSekllProdect(this.$route.params.id);
      }
    },
    getProdect: function getProdect(id) {
      var _this5 = this;

      this.fullscreenLoading = true;
      (0, _store.productDetailApi)(id).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee(res) {
          var info;
          return _index.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  info = res;
                  _this5.formValidate = {
                    image: _this5.$selfUtil.setDomain(info.image),
                    imagess: JSON.parse(info.sliderImage),
                    title: info.storeName,
                    info: info.storeInfo,
                    quota: '',
                    unitName: info.unitName,
                    sort: info.sort,
                    isShow: info.isShow,
                    tempId: info.tempId,
                    attr: info.attr,
                    attrValue: info.attrValue,
                    selectRule: info.selectRule,
                    content: info.content,
                    specType: info.specType,
                    productId: info.id,
                    giveIntegral: info.giveIntegral,
                    ficti: info.ficti,
                    timeId: _this5.$route.params.id ? Number(info.timeId) : _this5.$route.params.timeId ? Number(_this5.$route.params.timeId) : '',
                    startTime: info.startTime || '',
                    stopTime: info.stopTime || '',
                    timeVal: [],
                    status: 0,
                    num: 1
                  };

                  if (info.specType) {
                    _this5.$nextTick(function () {
                      info.attrValue.forEach(function (row) {
                        row.quota = row.stock;
                        row.attrValue = JSON.parse(row.attrValue);

                        for (var attrValueKey in row.attrValue) {
                          row[attrValueKey] = row.attrValue[attrValueKey];
                        }

                        row.image = _this5.$selfUtil.setDomain(row.image);

                        _this5.$refs.multipleTable.toggleRowSelection(row, true); // this.$set(row, 'checked', true)

                      });
                    });

                    _this5.ManyAttrValue = info.attrValue;
                    _this5.multipleSelection = info.attrValue;
                  } else {
                    info.attrValue.forEach(function (row) {
                      row.quota = row.stock;
                    });
                    _this5.ManyAttrValue = info.attrValue; // this.formValidate.attr = []
                  }

                  _this5.fullscreenLoading = false;

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this5.fullscreenLoading = false;
      });
    },
    getSekllProdect: function getSekllProdect(id) {
      var _this6 = this;

      this.fullscreenLoading = true;
      (0, _marketing.seckillStoreInfoApi)({
        id: id
      }).then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee2(res) {
          var info;
          return _index.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  info = res;
                  _this6.formValidate = {
                    image: _this6.$selfUtil.setDomain(info.image),
                    imagess: JSON.parse(info.sliderImage),
                    // title: info.title,
                    title: info.storeName,
                    // info: info.info,
                    info: info.storeInfo,
                    quota: info.quota,
                    unitName: info.unitName,
                    sort: info.sort,
                    isShow: info.isShow,
                    tempId: info.tempId,
                    attr: info.attr,
                    attrValue: info.attrValue,
                    selectRule: info.selectRule,
                    content: info.content,
                    specType: info.specType,
                    productId: info.productId,
                    giveIntegral: info.giveIntegral,
                    ficti: info.ficti,
                    timeId: Number(info.timeId),
                    // startTime: info.startTime || '',
                    startTime: info.startTimeStr || '',
                    // stopTime: info.stopTime || '',
                    stopTime: info.stopTimeStr || '',
                    status: info.status,
                    num: info.num,
                    timeVal: info.startTimeStr && info.stopTimeStr ? [info.startTimeStr, info.stopTimeStr] : [],
                    id: info.id
                  };

                  if (info.specType) {
                    _this6.ManyAttrValue = info.attrValue;

                    _this6.$nextTick(function () {
                      _this6.ManyAttrValue.forEach(function (item, index) {
                        item.attrValue = JSON.parse(item.attrValue);

                        for (var attrValueKey in item.attrValue) {
                          item[attrValueKey] = item.attrValue[attrValueKey];
                        }

                        item.image = _this6.$selfUtil.setDomain(item.image);

                        if (item.id) {
                          // 设置自动选中逻辑，只要id存在
                          _this6.$set(item, 'price', item.price);

                          _this6.$set(item, 'quota', item.quota);

                          _this6.$nextTick(function () {
                            _this6.$refs.multipleTable.toggleRowSelection(item, true);
                          });
                        }
                      });
                    });
                  } else {
                    _this6.ManyAttrValue = info.attrValue; // this.formValidate.attr = []
                  }

                  _this6.fullscreenLoading = false;

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this6.fullscreenLoading = false;
      });
    },
    handleSubmitNest2: function handleSubmitNest2(name) {
      var _this7 = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          if (_this7.formValidate.specType && _this7.multipleSelection.length === 0) return _this7.$message.warning("请填选择至少一个商品属性！");
          _this7.currentTab++;
        } else {
          return false;
        }
      });
    },
    // 提交
    handleSubmit: (0, _validate.Debounce)(function (name) {
      var _this8 = this;

      if (!this.formValidate.specType) {
        // this.formValidate.attr = []
        this.formValidate.attrValue = this.ManyAttrValue;
      } else {
        // this.multipleSelection.forEach((row) => {
        //   this.$set(row, 'checked', true)
        // });
        this.formValidate.attrValue = this.multipleSelection;
      }

      this.formValidate.images = JSON.stringify(this.formValidate.imagess);
      this.formValidate.attrValue.forEach(function (item) {
        item.attrValue = JSON.stringify(item.attrValue);
      });
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this8.fullscreenLoading = true;
          _this8.loading = true;
          _this8.$route.params.id ? (0, _marketing.seckillStoreUpdateApi)({
            id: _this8.$route.params.id
          }, _this8.formValidate).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee3() {
            return _index.default.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _this8.fullscreenLoading = false;

                    _this8.$message.success('编辑成功');

                    _this8.$router.push({
                      path: "/marketing/seckill/list"
                    });

                    _this8.$refs[name].resetFields();

                    _this8.formValidate.images = [];
                    _this8.loading = false;

                  case 6:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }))).catch(function () {
            _this8.fullscreenLoading = false;
            _this8.loading = false;
          }) : (0, _marketing.seckillStoreSaveApi)(_this8.formValidate).then( /*#__PURE__*/function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee4(res) {
              return _index.default.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      _this8.fullscreenLoading = false;

                      _this8.$message.success('新增成功');

                      _this8.$router.push({
                        path: "/marketing/seckill/list"
                      });

                      _this8.$refs[name].resetFields();

                      _this8.formValidate.images = [];
                      _this8.loading = false;

                    case 6:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4);
            }));

            return function (_x3) {
              return _ref4.apply(this, arguments);
            };
          }()).catch(function () {
            _this8.fullscreenLoading = false;
            _this8.loading = false;
          });
        } else {
          if (!_this8.formValidate.storeName || !_this8.formValidate.unitName || !_this8.formValidate.store_info || !_this8.formValidate.image || !_this8.formValidate.images) {
            _this8.$message.warning("请填写完整商品信息！");
          }
        }
      });
    }),
    handleSubmitUp: function handleSubmitUp() {
      if (this.currentTab-- < 0) this.currentTab = 0;
    },
    setTagsViewTitle: function setTagsViewTitle() {
      var title = '编辑秒杀商品';
      var route = Object.assign({}, this.tempRoute, {
        title: "".concat(title, "-").concat(this.$route.params.id)
      });
      this.$store.dispatch('tagsView/updateVisitedView', route);
    },
    // 移动
    handleDragStart: function handleDragStart(e, item) {
      this.dragging = item;
    },
    handleDragEnd: function handleDragEnd(e, item) {
      this.dragging = null;
    },
    handleDragOver: function handleDragOver(e) {
      e.dataTransfer.dropEffect = 'move';
    },
    handleDragEnter: function handleDragEnter(e, item) {
      e.dataTransfer.effectAllowed = 'move';

      if (item === this.dragging) {
        return;
      }

      var newItems = _toConsumableArray(this.formValidate.imagess);

      var src = newItems.indexOf(this.dragging);
      var dst = newItems.indexOf(item);
      newItems.splice.apply(newItems, [dst, 0].concat(_toConsumableArray(newItems.splice(src, 1))));
      this.formValidate.imagess = newItems;
    }
  }
};
exports.default = _default;